import { Stack } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux';
import NestedList from './nested-list';

type PopoverContentProps = {
  setAnchorEl: (anchorEl: HTMLDivElement | null) => void;
};

const contentSx = {
  padding: 2,
};

function PopoverContent({ setAnchorEl }: Readonly<PopoverContentProps>) {
  const data = useSelector((state: RootState) => state.api.data);

  return (
    <Stack sx={contentSx}>
      <NestedList data={data} setAnchorEl={setAnchorEl} />
    </Stack>
  );
}

export default PopoverContent;
